import * as types from './actionTypes';
import {FUNDING_APP_BASE_URL} from '../constants/global';
import { authenticatedFetch } from '@forwardfinancing/component-library';

export function statementsURL(){
  const url = `${FUNDING_APP_BASE_URL()}advances`;
  return url;
}

export function fetchStatements() {
  return dispatch => {
    return authenticatedFetch(statementsURL(), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(json => {
      dispatch(receiveStatements(json));
    });
  };
}

export function fetchStatement(id, page = 1) {
  return dispatch => {
    return authenticatedFetch(`${statementsURL()}/${id}?page=${page}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(json => {
      dispatch(receiveStatement(json));
    });
  };
}

export function receiveStatements(json) {
  return {type: types.RECEIVE_STATEMENTS, statements: json };
}

export function receiveStatement(json) {
  return {type: types.RECEIVE_STATEMENT, statement: json };
}
